import React from "react";
import DepartmentHome from "../components/DepartmentHome.jsx";

// Every HR_MODULES entry (hrConfig.js) is linked here via /admin/hr/<key>.
// When adding a module there, add its card to a section below.
const sections = [
  {
    heading: "People",
    items: [
      ["Employees", "/admin/employees", "Office staff, field duty caregivers, and applicants — one hub, start to finish"],
      ["Recruiting", "/admin/recruiting", "Track job applicants from application to hire"],
      ["New Hire Packets", "/admin/onboarding", "Send onboarding forms and collect e-signatures"],
      ["Attendance", "/admin/hr/attendance", "Daily clock-in/out, lateness and overtime records"],
      ["Leave Requests", "/admin/hr/leave_requests", "Review and approve time-off requests"],
      ["Performance Reviews", "/admin/hr/performance_reviews", "Periodic staff reviews, scores and manager comments"],
      ["Disciplinary Cases", "/admin/hr/disciplinary_cases", "Log incidents, warnings and actions taken"],
      ["HR Management", "/admin/hr", "This overview of every HR section"],
    ],
  },
  {
    heading: "Training",
    items: [
      ["Training Dashboard", "/admin/training", "Assignments, lesson progress, dementia status and skills sign-off"],
      ["Course Library", "/admin", "Build & manage video lessons, quizzes"],
      ["Compliance Dashboard", "/admin/dashboard", "Caregiver completion & audit reports"],
      ["Training Records", "/admin/hr/training", "Manually log training sessions, trainers, scores and certificates"],
    ],
  },
  {
    heading: "Pay and Money",
    items: [
      ["Payroll Approval", "/admin/payroll", "Approve caregiver timesheets and lock pay periods"],
      ["Salary Records", "/admin/hr/payroll", "Monthly salary, bonuses, deductions and net pay per employee"],
      ["Mileage", "/admin/mileage", "Review caregiver mileage logs and routes for reimbursement"],
      ["Staff Loans", "/admin/hr/staff_loans", "Loans issued to staff and their repayment balances"],
    ],
  },
  {
    heading: "Company",
    items: [
      ["Assets", "/admin/hr/assets", "Company equipment and who it is assigned to"],
      ["Inventory", "/admin/hr/inventory", "Supplies on hand, stock levels and suppliers"],
      ["Tasks", "/admin/hr/tasks", "Assign and track internal to-dos and deadlines"],
    ],
  },
];

const icons = {
  "Employees": "👤",
  "Recruiting": "🔎",
  "New Hire Packets": "🖊️",
  "Attendance": "🕒",
  "Leave Requests": "🏖️",
  "Performance Reviews": "📈",
  "Disciplinary Cases": "⚠️",
  "HR Management": "🗂️",
  "Training Dashboard": "🎓",
  "Course Library": "🎬",
  "Compliance Dashboard": "📊",
  "Training Records": "📚",
  "Payroll Approval": "💰",
  "Salary Records": "🧾",
  "Mileage": "🚗",
  "Staff Loans": "🏦",
  "Assets": "💼",
  "Inventory": "📦",
  "Tasks": "✅",
};

export default function HRHome() {
  return (
    <DepartmentHome
      title="Workforce & HR"
      description="Employee records, attendance, payroll, training, and more — admin only"
      sections={sections}
      icons={icons}
    />
  );
}
